import React , {Component } from 'react';
import { Link } from 'react-router-dom';
import AUX from '../../../hoc/Aux_';
import * as actionTypes from '../../../store/action';
import { connect } from 'react-redux';
import { InputLabel, Input, FormHelperText } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { postLogin } from '../../../api/login';
import {pushUserId } from '../../../actions/general';
import { withRouter, Redirect } from "react-router";

class Login extends Component{

    constructor(props) {
      super(props);
      this.state = {

        email:"",
        password: ""

      };
    }

    handleChangeText = (keys,e) => {
       this.setState({ [keys]: e.target.value });
    };

    handleLogin = () => {
      postLogin(this.state)
      .then(response => {
        localStorage.setItem('userID', response.data.UserID);
        localStorage.setItem('token', response.data.Authorization);
	localStorage.setItem('email', this.state.email);
        this.props.pushUserId(response.data.UserID);
        this.props.history.push(`/crud`);

      })
      .catch(error => {
        console.log(error);
      });
    }

    render(){
        return(
            <AUX>
              <section className=" section" align="center">
                  <div className="login-table">
                      <div className="login-table-cell">
                          <div className="container">
                              <div className="row justify-content-center mt-4">
                                  <div className="col-lg-4">
                                  <div className="text-center">
                                      <p className="text-dark-50 text-center">Sign in to administrator.</p>
                                  </div>
                                  <div className="bg-white p-4 mt-4 rounded">
                                          <div className="row">
                                              <div className="col-lg-12 mt-4">
                                                  <Input
                                                    disableUnderline={true}
                                                    type="email"
                                                    value = {this.state.email}
                                                    className="form-control"
                                                    placeholder="Email"
                                                    onChange = {(e) => this.handleChangeText("email",e)}
                                                  />
                                              </div>
                                              <div className="col-lg-12 mt-4">
                                                <Input
                                                  disableUnderline={true}
                                                  type="password"
                                                  value = {this.state.password}
                                                  className="form-control"
                                                  placeholder="Password"
                                                  onChange = {(e) => this.handleChangeText("password",e)}
                                                />
                                              </div>
                                              <div className="col-lg-12 mt-4">
                                                  <div id="my_icon" className="custom-control custom-checkbox">
                                                      <input type="checkbox" className="custom-control-input" id="customCheck1" />
                                                      <label className="custom-control-label" for="customCheck1">Remember me</label>
                                                  </div>
                                              </div>
                                              <div className="col-lg-12 mt-4 mb-3">
                                                  <button className="btn btn-custom w-100" onClick={this.handleLogin}>Sign in</button>
                                              </div>
                                          </div>
                                  </div>


                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </section>
           </AUX>
        );
    }
}


const mapStatetoProps = state => {
    return {
        loginpage: state.ui_red.loginpage
    };
}


export default withRouter(
  connect(mapStatetoProps, {pushUserId})
  (Login)
);
